import React, { useContext, useEffect, useState } from "react";
const AppContext = React.createContext();

const apiURL="https://www.omdbapi.com/?apikey=66e0a7f8";
const AppProvider = ({children}) =>{
    
    const[isLoading,setLoading]=useState(true)
    const[movie,setMovie]=useState([])
    const[isError,setError]=useState({show:false,msg:""})
    const[query,setquery]=useState("batman")

    const getMovies = async(url)=>{
       try{
          const res= await fetch(url)
          const data=await res.json();
          console.log(data)
          if(data.Response==="True"){
            setMovie(data.Search)
            setLoading(false)
            setError({show:false,msg:""})
          }
          else{
            setError({show:true,msg:data.Error})
          }
       }catch(error){
        console.log(error)
       }
    }
   useEffect(()=>{
   let timeOut= setTimeout(()=>{
      getMovies(`${apiURL}&s=${query}`);
    },800)

   return ()=> clearTimeout(timeOut)
    
   },[query])
    return (
    <AppContext.Provider value={{movie,isLoading,isError,query,setquery}}>{children}</AppContext.Provider>
    )
   
    
}
const useGlobalContext = () =>{
    return useContext(AppContext)
}

   
export {AppContext , AppProvider,useGlobalContext}